import { PartnerAnalysisGroup1 } from '../../entities/control-tables/partner-analysis-group1';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class PartnerAnalysisGroup1Request extends BaseRequest {

    partnerAnalysisGroup1 : PartnerAnalysisGroup1

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.partnerAnalysisGroup1 = new PartnerAnalysisGroup1()
  }
}